import { Alert } from '@festina-life/ui/feedback'
import { useTranslate } from '@festina-life/ui/hooks'
import type { ReactNode } from 'react'

import { IMAGE_EXTENSIONS, VIDEO_EXTENSIONS } from './constants'
import { MarkdownImage } from './MarkdownImage'
import { MarkdownVideo } from './MarkdownVideo'

export type MediaComponentProps = {
  src?: string
  alt?: string
  children?: ReactNode
}

export const MarkdownMedia = ({ src, alt }: MediaComponentProps) => {
  const translate = useTranslate()
  if (!src) {
    return null
  }

  if (
    ![...VIDEO_EXTENSIONS, ...IMAGE_EXTENSIONS].find((ext) =>
      src.toLowerCase().endsWith(ext),
    )
  ) {
    return (
      <p className="flex gap-x-2 items">
        <Alert severity="error" variant="mini" />
        <span>{src}</span>
        <span>({translate('markdownViewer.media.unsupportedFormat')})</span>
      </p>
    )
  }

  // Check if the file is a video based on its extension
  const isVideo = VIDEO_EXTENSIONS.some((ext) =>
    src.toLowerCase().endsWith(ext),
  )

  return isVideo ? (
    <MarkdownVideo src={src} alt={alt} />
  ) : (
    <MarkdownImage src={src} alt={alt} />
  )
}
